import React from "react";
import { Button, Card, Icon, Text, VisuallyHidden, IconName } from "@telia/teddy";
import { Variant } from "@telia/teddy/dist/components/card/utils";

interface LoginCardProps {
    content?: string;
    icon?: IconName;
    onClick?: () => Promise<void>;
    title?: string;
    variant?: Variant;
}

const LoginCard: React.FC<LoginCardProps> = ({ onClick = async () => {}, variant = "gray", content, icon, title }) => {
    // TODO(dark-mode): review, Telia brand purple logo color; suggested text-brand or text-interactive-link
    const color = icon === "telia-logo" ? "#990AE3" : undefined;
    return (
        <Card variant={variant} layout="navigation-horizontal-small">
            {icon && (
                <Card.Illustration>
                    <Icon name={icon} size="lg" color={color} aria-hidden="true" focusable="false" />
                </Card.Illustration>
            )}
            <Card.Heading>{title}</Card.Heading>
            {content && (
                <Card.Content>
                    <Text asChild variant="paragraph-100">
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </Text>
                </Card.Content>
            )}
            <Card.Button asChild aria-label="Logg inn" iconOnly>
                <Button size="md" onClick={onClick}>
                    <VisuallyHidden>Logg inn</VisuallyHidden>
                    <Icon name="arrow-right" aria-hidden="true" focusable="false" />
                </Button>
            </Card.Button>
        </Card>
    );
};

export default LoginCard;
